const img1 = require("../images/slider/slide_1.png").default
const img2 = require("../images/slider/slide_2.png").default
const img3 = require("../images/slider/slide_3.png").default

const heroSliderData = [
    {
        title: "Premium Pima Women's Polo",
        description: "Referring to class, it is impossible not to mention the pima fabric line. It creates the best quality for any fashion product. The pima yarn is twice as long and thicker than regular cotton yarn thanks to advanced weaving technology. That makes the structure of the polo shirt strong, durable, minimizes ruffles, smooth, colorfast, extremely ensuring the user's health.",
        img: img1,
        color: "blue",
        path: "/catalog/ao-thun-dinosaur-01"
    },
    {
        title: "Fashionable Women's Polo Modal",
        description: "Modal women's polo shirt uses high-quality environmentally friendly fabric technology to produce exclusive anti-shrink fabric, modal women's polo shirt is a suitable product for those of you who have a dynamic working environment like today.",
        img: img2,
        path: "/catalog/ao-thun-dinosaur-02",
        color: "pink"
    },
    {
        title: "Polo Nữ Coolmax Lacoste",
        description: "Women's polo shirt model is made of coolmax material that feels cool to wear. This coolmax polo shirt design features an ultra-comfortable fit. Creating neatness promises to be a very hot polo shirt in the near future",
        img: img3,
        path: "/catalog/ao-thun-dinosaur-03",
        color: "orange"
    }
]

export default heroSliderData